import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Label } from 'core/components/label';
import useStyles from './header-value.styles';

// A label above its value: the "Read-only value / Stacked" pattern the header's bottom row uses.
const HeaderValue = ({ label, children, className }) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.container, className)}>
      <Label type="infoLabel" className={classes.label}>
        {label}
      </Label>
      <div className={classes.value}>{children}</div>
    </div>
  );
};

HeaderValue.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

HeaderValue.defaultProps = {
  className: undefined
};

export default HeaderValue;
